import BrowsePage from './BrowsePage';
import BrowsePageContainer from './BrowsePage.container';

export default BrowsePageContainer(BrowsePage);
